import TemplateTypes from './TemplateTypes';

export default TemplateTypes;



// WEBPACK FOOTER //
// ./src/views/templateTypes/index.js